import React, { useState } from "react";
import { Form, Alert, Container, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { Btn } from "../../../shared/Btn";

const readTempTokenFromHash = (): string | null => {
  // Fragment is preferred over ?token= because it never hits server access
  // logs and isn't sent in Referer to third parties. Scrubs itself from
  // window.location after read so it doesn't persist in browser history
  // copy-paste. Back-compat: falls back to ?token= during the transition
  // deploy; can be dropped once the old redirects are gone.
  if (typeof window === "undefined") return null;
  const raw = window.location.hash.replace(/^#/, "");
  if (!raw) return null;
  const parsed = new URLSearchParams(raw);
  return parsed.get("token");
};

const scrubHashFromUrl = () => {
  if (typeof window === "undefined") return;
  if (window.history && typeof window.history.replaceState === "function") {
    window.history.replaceState(
      null,
      "",
      window.location.pathname + window.location.search
    );
  }
};

const TwoFactorAuth = () => {
  const [token, setToken] = useState("");
  const location = useLocation();
  const [tempToken] = useState<string>(() => {
    const fromHash = readTempTokenFromHash();
    if (fromHash) {
      scrubHashFromUrl();
      return fromHash;
    }
    const fromQuery = queryString.parse(location.search).token;
    return typeof fromQuery === "string" ? fromQuery : "";
  });

  const handleSubmit = (e: React.FormEvent) => {
    if (!token || !tempToken) {
      e.preventDefault();
    }
  };

  return (
    <Container>
      <Row className="justify-content-md-center mt-5">
        <Col md={6}>
          <h2 className="text-center mb-4">Two-Factor Authentication</h2>
          <Form
            onSubmit={handleSubmit}
            action="/api/v1/auth/verify2fa"
            method="POST"
          >
            <Form.Group className="mb-3">
              <Form.Label>Enter 2FA Code</Form.Label>
              <Form.Control
                type="text"
                name="token"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="Enter 6-digit code"
                required
                pattern="[0-9]{6}"
              />
            </Form.Group>

            <input type="hidden" name="tempToken" value={tempToken || ""} />

            <Btn variant="primary" type="submit" className="w-100">
              Verify
            </Btn>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default TwoFactorAuth;
